import { RestOptions, Patient } from '@csp/csp-common-model';
import { UserRestServiceV1 } from '@csp/dmdp-api-client';
import { PatientRescreenMetaFactory } from '../model/PatientRescreenMetaFactory';

const updatePatientRescreenInfoMeta = async (
  apiOptions: RestOptions,
  patientToUpdate: Patient,
  rescreenedPatient: Patient,
): Promise<void> => {
  const rescreenMeta = PatientRescreenMetaFactory.createUpdatedPatientRescreenMetaV1(rescreenedPatient);
  await UserRestServiceV1.addOrUpdateMeta(apiOptions, patientToUpdate.userV1, rescreenMeta);
};

export const PatientRescreenMetaService = {
  updatePatientRescreenInfoMeta,
};
